
    import EducationCoreMixin from '@/components/Education/EducationCoreMixin';
    import EducationSlider from '@/components/Education/EducationSlider';
    import EducationScroll from '@/components/Education/EducationScroll';

    export default {
        name: 'EducationSlideWidget',

        components: {
            EducationScroll,
            EducationSlider,
        },

        mixins: [EducationCoreMixin],

        provide() {
            return {
                pageReferralElement: this.pageReferralElement,
            };
        },

        props: {
            titleContainerClasses: {
                type: String,
                default: 'container',
            },

            titleCenter: {
                type: Boolean,
                default: false,
            },

            pageReferralElement: {
                type: String,
                default: '',
            },
        },
    };
